import { Koi } from '@ksyos/koi';
import { afwijkingenSchema } from './sharedSchemas';

export const ocrkV1FinalRequest = Koi.object().keys({
    question: Koi.string().max(1000),
    selectedDiagnosticReportProviderOrganizationId: Koi.string().uuid(),
    selectedDiagnosticReportProviderPractitionerId: Koi.string().uuid().allow(null),
    toelichting: Koi.string().max(1000).allow(null),
});

export const ocrkV1DraftRequest = ocrkV1FinalRequest.concat(
    Koi.object().keys({
        question: Koi.string().max(1000).allow(null),
        selectedDiagnosticReportProviderOrganizationId: Koi.string().uuid().allow(null),
    })
);

const ocrkV1BasicDiagnosticReport = Koi.object().keys({
    betrokkene_gesproken_per_videogesprek: Koi.boolean(),
    is_grading_accepted: Koi.boolean(),
    relevante_comorbiditeit: Koi.boolean(),
    toelichting: Koi.string().max(1000).allow(null),
    toelichting_relevante_comorbiditeit: Koi.when('relevante_comorbiditeit', {
        is: true,
        otherwise: Koi.valid(null),
        then: Koi.string().max(1000).allow(null),
    }),
    toelichting_verworven_nystagmus: Koi.when('afwijkingen.verworven_nystagmus', {
        is: true,
        otherwise: Koi.valid(null),
        then: Koi.string().max(1000).allow(null),
    }),
    toelichting_videogesprek: Koi.when('betrokkene_gesproken_per_videogesprek', {
        is: true,
        otherwise: Koi.valid(null),
        then: Koi.string().max(1000).allow(null),
    }),
});

export const ocrkV1FinalDiagnosticReport = ocrkV1BasicDiagnosticReport.concat(
    Koi.object().keys({
        afwijkingen: Koi.when('afwijkingen_gevonden', {
            is: true,
            otherwise: afwijkingenSchema,
            then: afwijkingenSchema.anyFilledIn(),
        }),
        afwijkingen_gevonden: Koi.when('is_grading_accepted', {
            is: true,
            otherwise: Koi.boolean(),
            then: Koi.boolean().allow(null),
        }),
    })
);

export const ocrkV1DraftDiagnosticReport = ocrkV1BasicDiagnosticReport.concat(
    Koi.object().keys({
        afwijkingen: afwijkingenSchema,
        afwijkingen_gevonden: Koi.boolean().allow(null),
        betrokkene_gesproken_per_videogesprek: Koi.boolean().allow(null),
        is_grading_accepted: Koi.boolean().allow(null),
        relevante_comorbiditeit: Koi.boolean().allow(null),
    })
);
